<template>
  <div class="row" justify="center">
    <v-col md="12">
      <v-breadcrumbs :items="items">
        <template v-slot:divider>
          <v-icon>mdi-forward</v-icon>
        </template>
      </v-breadcrumbs>
    </v-col>
    <v-col
      ><v-sheet color="white" elevation="1" class="pa-5">
        <h2>Learner Terms and Conditions Upload/Download</h2>
        <v-divider></v-divider>
        <DocDownloader :data-array="passData" upload-type="learner" />
        <!-- //<DocDownloader dataArray="hello" /> -->
      </v-sheet>
    </v-col>
  </div>
</template>

<script>
import DocDownloader from "@/components/Admin/DocDownloader.vue";
import { M_OA, LOAD_LEARNER_TC, GET_LEARNER_TC } from "@/store/mutation-list";
import { mapActions, mapGetters } from "vuex";
//import { Footer } from "@/components/Footer.vue";
export default {
  name: "UploadLeanerTC",
  components: { DocDownloader },

  data: () => ({
    items: [
      {
        text: "Admin Dashboard",
        disabled: false,
        href: "/dashboard/adminhome",
      },
      {
        text: "Upload/Download Learner T&C",
        disabled: true,
        href: "/dashboard/uploadleanertc",
      },
    ],
  }),
  computed: {
    ...mapGetters({
      passData: `${M_OA}${GET_LEARNER_TC}`,
    }),
  },
  methods: {
    ...mapActions({
      loadFileHistory: `${M_OA}${LOAD_LEARNER_TC}`,
    }),
  },
  created() {
    this.loadFileHistory();
  },
};
</script>

<style></style>
